import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';

import { cn } from '@app/shared/utils/common';

interface BlueContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  withShadow?: boolean;
  asChild?: boolean;
}

export function BlueContainer({
  children,
  withShadow = false,
  asChild = false,
  className,
  ...props
}: BlueContainerProps) {
  const Comp = asChild ? Slot : 'div';
  return (
    <Comp
      className={cn('rounded-[10px] bg-card p-4', withShadow && 'shadow-blue', className)}
      {...props}
    >
      {children}
    </Comp>
  );
}
